<template>
  <div class="recurring-datetime-picker">
    <h3 v-if="!hideTitle">{{ $t('components.day-time-picker.title') }}</h3>
    <p v-if="!hideTitle">{{ $t('components.day-time-picker.text-1') }}</p>
    <p class="select-day-time">{{ $t('components.day-time-picker.select-day-time') }}</p>
    <div class="day-picker">
      <button v-if="hideTitle" v-bind:class="{ selected: deactivated }" v-on:click="deactivateAllDays">{{ $t('components.day-time-picker.days.none') }}</button>
      <button v-bind:class="{ selected: weekday.Monday }" v-on:click="toggleDay('Monday')">{{ $t('components.day-time-picker.days.mon.short') }}</button>
      <button v-bind:class="{ selected: weekday.Tuesday }" v-on:click="toggleDay('Tuesday')">{{ $t('components.day-time-picker.days.tue.short') }}</button>
      <button v-bind:class="{ selected: weekday.Wednesday }" v-on:click="toggleDay('Wednesday')">{{ $t('components.day-time-picker.days.wed.short') }}</button>
      <button v-bind:class="{ selected: weekday.Thursday }" v-on:click="toggleDay('Thursday')">{{ $t('components.day-time-picker.days.thu.short') }}</button>
      <button v-bind:class="{ selected: weekday.Friday }" v-on:click="toggleDay('Friday')">{{ $t('components.day-time-picker.days.fri.short') }}</button>
    </div>
    <div class="time-picker">
      <p :class="{ hidden: deactivated }">{{ $t('components.day-time-picker.at') }}</p>
      <datetime
        v-model="time"
        type="time"
        :class="{ hidden: deactivated }"
        min-datetime="1970-01-01T08:00:00.000Z"
        max-datetime="1970-01-01T16:59:00.000Z"
        :minute-step="5"
        :title="this.$t('components.day-time-picker.select-time')"
        ></datetime>
    </div>
    <p v-if="!anyWeekday && !settings">{{ $t('components.day-time-picker.before-selection-text') }}</p>
    <p v-if="!anyWeekday && settings">{{ $t('components.day-time-picker.deactivate-text') }}</p>
    <p v-if="anyWeekday">
      {{ $t('components.day-time-picker.after-selection-text_1') }}
      <span v-bind:class="{ hidden: !weekday.Monday }" class="selected-datetime" id="monday">{{ $t('components.day-time-picker.days.mon.long') }}</span>
      <span v-bind:class="{ hidden: !weekday.Tuesday }" class="selected-datetime" id="tuesday">{{ $t('components.day-time-picker.days.tue.long') }}</span>
      <span v-bind:class="{ hidden: !weekday.Wednesday }" class="selected-datetime" id="wednesday">{{ $t('components.day-time-picker.days.wed.long') }}</span>
      <span v-bind:class="{ hidden: !weekday.Thursday }" class="selected-datetime" id="thursday">{{ $t('components.day-time-picker.days.thu.long') }}</span>
      <span v-bind:class="{ hidden: !weekday.Friday }" class="selected-datetime" id="friday">{{ $t('components.day-time-picker.days.fri.long') }}</span>
      {{ $t('components.day-time-picker.after-selection-text_2') }}
      <span class="selected-datetime">{{ time | localTimeString }}</span>
      {{ $t('components.day-time-picker.after-selection-text_3') }}
      <span :class="{ hidden: !phonenumber }" class="selected-datetime">{{ phonenumber }}</span>
      {{ $t('components.day-time-picker.after-selection-text_4') }}
    </p>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'recurring-datetime-picker',
  props: {
    settings: Boolean,
    hideTitle: Boolean,
  },
  methods: {
    toggleDay (day) {
      this.$root.recurringPicker.weekday[day] = !this.$root.recurringPicker.weekday[day]
      if (!this.anyWeekday) {
        this.$root.recurringPicker.deactivated = true
      } else {
        this.$root.recurringPicker.deactivated = false
      }
    },
    deactivateAllDays () {
      this.$root.recurringPicker.deactivated = true
      this.$root.recurringPicker.weekday = {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
      }
    }
  },
  computed: {
    weekday () {
      return this.$root.recurringPicker.weekday
    },
    deactivated () {
      return this.$root.recurringPicker.deactivated
    },
    time: {
      get () {
        return this.$root.recurringPicker.time
      },
      set (time) {
        this.$root.recurringPicker.time = time
      }
    },
    anyWeekday () {
      return this.$root.recurringPicker.weekday.Monday ||
        this.$root.recurringPicker.weekday.Tuesday ||
        this.$root.recurringPicker.weekday.Wednesday ||
        this.$root.recurringPicker.weekday.Thursday ||
        this.$root.recurringPicker.weekday.Friday
    },
    phonenumber () {
      return this.$root.phonenumber.formatted
    }
  },
  filters: {
    localTimeString (timeString) {
      return DateTime.fromISO(timeString).setLocale('de').toLocaleString(DateTime.TIME_SIMPLE)
    }
  }
}
</script>

<style lang=scss>
@import '@/assets/styles/_variable.scss';

.recurring-datetime-picker {
  h3 {
    margin: 0;
  }
  .selected-datetime {
    background-color: $dark-text-color;
    color: $main-bg;
    font-size: 0.8em;
    padding: 5px 5px;
    margin: 0 1px;
    white-space: nowrap;
  }

  .select-day-time {
    margin-bottom: 0;
  }

  .day-picker {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      flex: 1;
      background-color: $divider-color;
      color: $dark-text-color;
      font-size: 1em;
      @media (max-width:419px) {
        font-size: .7em;
      }
      text-align: center;
      cursor: pointer;
      transition: none !important;
      padding: 1em .5em;
      &.selected {
        background-color: $dark-text-color;
        color: $main-bg;
      }

      &:not(.selected):hover {
        text-decoration: underline;
      }
    }
  }

  .time-picker {
    display: flex;
    margin: 0.5em 0;

    p {
      font-size: 2em;
      padding: 0em 1em;
    }

    div.vdatetime {
      flex: 1 0;
      display: flex;

      input.vdatetime-input {
        font-size: 2.8em;
        width: 100%;
        height: 100%;
        background-color: $divider-color;
        border: none;
        text-align: center;
        color: $dark-text-color;
        font-family: $font-family-primary;
        cursor: pointer;

        &:hover {
          background-color: rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}

.vdatetime-popup {
  font-family: $font-family-primary !important;

  .vdatetime-popup__header {
    background-color: $dark-text-color !important;
    color: $main-bg !important;
  }

  .vdatetime-time-picker__item--selected {
    color: $dark-text-color !important;
  }

  .vdatetime-popup__actions__button {
    color: $dark-text-color !important;
  }
}
</style>
